<template>
  <div
    style="min-width: 100px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div :class="'input-group'">
      <v-text-field
        v-model="value"
        v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
        :rules="isRequired ? [v => !!v || 'Required'] : []"
        :disabled="readonly"
        :aria-label="fieldType.text || question.text"
        browser-autocomplete="off"
        @focus="focus"
        @blur="save"
      >
        <v-icon
          v-if="answer.status"
          slot="prepend"
        >
          {{ statusIconClass }}
        </v-icon>
      </v-text-field>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'TextAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      value: '',
      savedValue: '',
      failed: false
    }
  },
  beforeMount () {
    this.value = this.answer.text || ''
  }
}
</script>
